import React from 'react';
import {ProtectedRoute} from '../../_common/components/Permissions';
import UsersActions from '../pages';
import {pathnames as P} from '../../_common/constants/pathnames';
import {subjects as S} from '../../_common/constants/permissionSubjects';

export const notificationsRoute = (
  <ProtectedRoute
    subject={S.NOTIFICATIONS_PAGE}
    path={P.NOTIFICATIONS_PAGE}
    component={UsersActions}
  />
);
